import { type Maybe } from 'graphql/jsutils/Maybe';
import { type ReactNode } from 'react';
import { EmptyInfoCardTemplate } from '@components/_templates/InfoCardTemplate/components/EmptyInfoCardTemplate';
import { type Component } from '@gql/graphql';
import { type RequestRow } from '@pages/notification-components/components/RequestsCard/RequestsTable/columns';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';
import { ComponentInfoCard } from './ComponentInfoCard/ComponentInfoCard';
import { RequestInfoCard } from './RequestInfoCard/RequestInfoCard';

interface InfoCardProps {
    component: Maybe<Component>;
    request: Maybe<ComponentCreateRequestMapped>;
    requests: RequestRow[];
}

export function InfoCard({
    component,
    request,
    requests,
}: InfoCardProps): ReactNode {
    if (component) {
        return <ComponentInfoCard component={component} />;
    }

    if (requests.length > 0) {
        return <RequestInfoCard request={request} requests={requests} />;
    }

    return <EmptyInfoCardTemplate />;
}
